


export default function txLogs(params) {
  if (process.env.NODE_ENV !== 'production') {
    return false
  }
  let addrObj = JSON.parse(localStorage.getItem('location'))
  const tmpParams = {
    vid: localStorage.getItem('openid') || "0",
    sid: localStorage.getItem('session_id') || "0",
    ua: navigator.userAgent,
    url: location.href,
    ref: localStorage.getItem('fromPath') ? (location.origin + localStorage.getItem('fromPath')) : '',
    go: localStorage.getItem('toPath') ? (location.origin + localStorage.getItem('toPath')) : '',
    bpm: '',
    scene: '',
    scene_name: '',
    act_id: localStorage.getItem('act_id') || "0",
    brand_id: localStorage.getItem('brand_id') || "0",
    shop_id: localStorage.getItem('shop_id') || "0",
    kpi_user_id: localStorage.getItem('kpi_user_id') || "0",
    share_user_id: localStorage.getItem('share_user_id') || "0",
    user_id: localStorage.getItem('user_id') || "0",
    addr: addrObj?.data ? (addrObj?.data?.province + '-' + addrObj?.data?.city + '-' + addrObj?.data?.district) : '',
    adcode: addrObj?.data?.adcode || '',
    remark: '',
    ver: '1.0.0',
    appid: "wxdc7696bde91deb24",
    ct: new Date().getTime(),
  }
  // 实例化

  let jsonParams = Object.assign(tmpParams, params)
  console.log('日志', jsonParams)
  const tencentLog = new tencentlogClass();

  // 请求日志签名地址
  // const ticketURL = "https://wx.youxiangzb.com/data/v1/cls/signature/get";
  const ticketURL = `${location.origin}/data/v1/cls/signature/get`;

  // 写入请求签名地址
  tencentLog.configTicketURL(ticketURL);
  // 调取请求日志写入方法
  tencentLog.sendLog(jsonParams)
}